import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { UserInfo } from '@Entities/user/user'
import UserRowComponent from '@Components/UserRowComponent'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'

const UsersForUserTable = () => {
    const { rightsholderUserStore } = useContext<RootStore>(StoresContext)
    const usersForUser = rightsholderUserStore.rightsholderUsersForUser
    return (
        <div className="list">
            {usersForUser?.users.map((userData: UserInfo) => (
                <UserRowComponent key={userData.exposedId} userData={userData} noDots />
            ))}
        </div>
    )
}

export default observer(UsersForUserTable)
